module.exports = __webpack_public_path__ + "static/media/AllHome.fcf47756.png";